import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Card, CardContent, Grid, Chip,
  CircularProgress, Alert, Button, Dialog, DialogTitle,
  DialogContent, DialogActions, TextField, Select, MenuItem,
  FormControl, InputLabel, Tabs, Tab, Autocomplete, TableContainer,
  Table, TableBody, TableCell, TableHead, TableRow, Paper,
  Pagination, IconButton, FormControlLabel, Switch
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import {
  getTiposIntervencion, getIntervencionesV2, crearIntervencionV2,
  getIntervencionDetalle, añadirTiempo, editarTiempo, solicitarMaterial,
  guardarInforme, aprobarIntervencion, getClientes, getMaquinas,
  getUsuarios, getRecambios, actualizarTecnicosIntervencion,
  actualizarDatosIntervencion, aprobarMaterial, rechazarMaterial, eliminarMaterial,
  getControlEconomico, actualizarTarifas, generarInformeIA, 
  descargarInformeIntervencion,
  getFotosIntervencion, subirFotoIntervencion, borrarFotoIntervencion,
  getFotoIntervencionBlob, rechazarIntervencion, calcularTiempo,  
  previsualizarBorradoIntervencion, borrarIntervencion
} from '../api';
import InformeAcciones from '../components/InformeAcciones';
import Tarifario from '../components/Tarifario';
import GastosTab from '../components/GastosTab';
import PropuestaFacturaIntervencion from '../components/PropuestaFacturaIntervencion';
import * as XLSX from 'xlsx';

const estadoColor: any = {
  en_curso: 'warning',
  pendiente_aprobacion: 'info',
  completada: 'success'
};

export const UBICACIONES_AVERIA = [
  { v: 'chasis',          l: '🚛 Chasis' },
  { v: 'superestructura', l: '🏗 Superestructura' },
  { v: 'otros',           l: '📦 Otros / equipo auxiliar' },
];
export const CARACTERES_AVERIA = [
  { v: 'mecanico',   l: '🔧 Mecánico' },
  { v: 'electrico',  l: '⚡ Eléctrico' },
  { v: 'hidraulico', l: '💧 Hidráulico' },
  { v: 'neumatico',  l: '💨 Neumático' },
  { v: 'software',   l: '💻 Software' },
];

const estadoLabel: any = {
  en_curso: 'En curso',
  pendiente_aprobacion: 'Pendiente aprobación',
  completada: 'Completada'
};

export default function Intervenciones() {
  const [tab, setTab] = useState(0);
  const [enCurso, setEnCurso] = useState<any[]>([]);
  const [historico, setHistorico] = useState<any[]>([]);
  const [historicoTotal, setHistoricoTotal] = useState(0);
  const [historicoPages, setHistoricoPages] = useState(1);
  const [pagina, setPagina] = useState(1);
  const [filtros, setFiltros] = useState({ search: '', tipo: '', desde: '', hasta: '', ubicacion: '', caracter: '', origen: '' });
  const [loading, setLoading] = useState(true);
  const [tipos, setTipos] = useState<string[]>([]);
  const [nuevaDialog, setNuevaDialog] = useState(false);
  const [detalleId, setDetalleId] = useState<number | null>(null);

  const [nueva, setNueva] = useState({
    tipo_intervencion: '', cliente_id: null as any, maquina_id: null as any,
    tecnicos_ids: [] as any[], descripcion: ''
  });
  const [clientesLista, setClientesLista] = useState<any[]>([]);
  const [maquinasLista, setMaquinasLista] = useState<any[]>([]);
  const [empleadosLista, setEmpleadosLista] = useState<any[]>([]);
  const [porValorar, setPorValorar] = useState<any[]>([]);
  const [valorarId, setValorarId] = useState<number | null>(null);

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const [permisosUsuario, setPermisosUsuario] = useState<string[]>([]);
  const puedeVerTarifario = user.rol === 'admin' || permisosUsuario.includes('gestionar_tarifario');
  const esAdmin = user.rol === 'admin' || permisosUsuario.includes('gestionar_intervenciones');
  const puedeAprobar = user.rol === 'admin' || permisosUsuario.includes('aprobar_intervenciones');
  const puedeVerEconomico = user.rol === 'admin' || permisosUsuario.includes('cost_control_maquinas');

  const cargar = () => {
    setLoading(true);
    Promise.all([
      getIntervencionesV2({ estado: 'en_curso', limit: 100 }),
      getIntervencionesV2({ estado: 'pendiente_aprobacion', limit: 100 }),
      getIntervencionesV2({ estado: 'pendiente_valoracion', limit: 100 })
    ]).then(([curso, pendientes, valorar]) => {
      setEnCurso([...curso.items, ...pendientes.items]);
      setPorValorar(valorar.items || []);
    }).finally(() => setLoading(false));
    cargarHistorico();
  };

  const cargarHistorico = () => {
    getIntervencionesV2({
      estado: 'completada', page: pagina, limit: 20,
      search: filtros.search, tipo: filtros.tipo,
      desde: filtros.desde, hasta: filtros.hasta,
      ubicacion: filtros.ubicacion, caracter: filtros.caracter, origen: filtros.origen,
    }).then((d: any) => {
      setHistorico(d.items);
      setHistoricoTotal(d.total);
      setHistoricoPages(d.pages);
    });
  };

  const exportarRepositorio = async () => {
    const d: any = await getIntervencionesV2({
      estado: 'completada', page: 1, limit: 5000,
      search: filtros.search, tipo: filtros.tipo,
      desde: filtros.desde, hasta: filtros.hasta,
      ubicacion: filtros.ubicacion, caracter: filtros.caracter, origen: filtros.origen,
    });
    const filas = (d.items || []).map((i: any) => ({
      'Nº': i.id,
      'Fecha': (i.fecha || '').slice(0, 10),
      'Nº serie': i.numero_serie || '',
      'Modelo': (i.modelo || '').replace('SANY ', ''),
      'Cliente': i.cliente_nombre || '',
      'Ubicación': i.averia_ubicacion || '',
      'Carácter': i.averia_caracter || '',
      'Descripción': i.descripcion || '',
      'Pieza PN': i.pieza_pn || '',
      'Tipo': i.tipo_intervencion || '',
      'Horas': i.horas || 0,
      'Origen': i.origen_registro || 'crm',
    }));
    if (!filas.length) { alert('No hay averías con esos filtros'); return; }
    const ws = XLSX.utils.json_to_sheet(filas);
    ws['!cols'] = [{wch:6},{wch:12},{wch:17},{wch:12},{wch:24},{wch:16},{wch:12},{wch:50},{wch:20},{wch:18},{wch:7},{wch:10}];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Averías');
    XLSX.writeFile(wb, `Repositorio_averias_${new Date().toISOString().slice(0,10)}.xlsx`);
  };

  useEffect(() => {
    cargar();
    getTiposIntervencion().then(setTipos);
    if (user.rol !== 'admin') {
      import('../api').then(({ getMisPermisos }) => {
        getMisPermisos().then(setPermisosUsuario).catch(() => setPermisosUsuario([]));
      });
    }
    getClientes().then(setClientesLista);
    getUsuarios().then(setEmpleadosLista);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Recargar el histórico al cambiar de página o de filtros
  useEffect(() => {
    cargarHistorico();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagina, filtros]);

  const cambiarFiltro = (campo: string, valor: string) => {
    setPagina(1); // al filtrar, volver a la primera página
    setFiltros(prev => ({ ...prev, [campo]: valor }));
  };
  const handleClienteChange = async (cliente: any) => {
    setNueva({ ...nueva, cliente_id: cliente?.id || null, maquina_id: null });
    if (cliente) {
      const todasMaquinas = await getMaquinas();
      setMaquinasLista(todasMaquinas.filter((m: any) => m.cliente_id === cliente.id));
    } else {
      setMaquinasLista([]);
    }
  };

  const handleCrear = async () => {
    if (!nueva.tipo_intervencion || !nueva.cliente_id || !nueva.maquina_id || nueva.tecnicos_ids.length === 0) {
      alert('Completa todos los campos obligatorios');
      return;
    }
    try {
      await crearIntervencionV2(nueva);
      setNuevaDialog(false);
      setNueva({ tipo_intervencion: '', cliente_id: null, maquina_id: null, tecnicos_ids: [], descripcion: '' });
      cargar();
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Error al crear la intervención');
    }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' } }}>
          🔧 Intervenciones
        </Typography>
        <Button
          variant="contained" startIcon={<AddIcon />}
          onClick={() => setNuevaDialog(true)}
          sx={{ bgcolor: '#4f46e5' }}
        >
          Nueva intervención
        </Button>
      </Box>

      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3 }}>
        <Tab label={`📋 En curso (${enCurso.length})`} />
        <Tab label={`💶 Por valorar (${porValorar.length})`} />
        <Tab label={`📚 Histórico (${historicoTotal})`} />
        {puedeVerTarifario && <Tab label="💶 Tarifario" />}
      </Tabs>

      {tab === 3 && puedeVerTarifario && <Tarifario puedeEditar={puedeVerTarifario} />}

      {loading && <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}><CircularProgress /></Box>}

      {tab === 0 && (
        <Grid container spacing={2}>
          {enCurso.map(i => (
            <Grid item xs={12} sm={6} key={i.id}>
              <Card sx={{ borderRadius: 3, cursor: 'pointer', '&:hover': { boxShadow: 4 } }} onClick={() => setDetalleId(i.id)}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography sx={{ fontWeight: 600 }}>#{i.id} — {i.tipo_intervencion}</Typography>
                    <Chip label={estadoLabel[i.estado]} color={estadoColor[i.estado]} size="small" />
                  </Box>
                  <Typography variant="body2">👤 {i.cliente_nombre}</Typography>
                  <Typography variant="body2">🏗 {i.modelo} #{i.numero_serie}</Typography>
                  <Typography variant="caption" color="text.secondary" display="block">
                    👷 {i.tecnicos?.map((t: any) => t.nombre).join(', ')}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
          {enCurso.length === 0 && !loading && (
            <Grid item xs={12}><Alert severity="info">No hay intervenciones en curso.</Alert></Grid>
          )}
        </Grid>
      )}

      {tab === 1 && (
        <Grid container spacing={2}>
          {porValorar.length === 0 && (
            <Grid item xs={12}>
              <Alert severity="info">No hay intervenciones pendientes de valorar.</Alert>
            </Grid>
          )}
          {porValorar.map(i => (
            <Grid item xs={12} sm={6} key={i.id}>
              <Card sx={{ borderRadius: 3, borderLeft: '4px solid #f59e0b' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography sx={{ fontWeight: 600 }}>#{i.id} — {i.tipo_intervencion}</Typography>
                    <Chip label="Por valorar" color="warning" size="small" />
                  </Box>
                  <Typography variant="body2">👤 {i.cliente_nombre}</Typography>
                  <Typography variant="body2">🏗 {i.modelo} #{i.numero_serie}</Typography>
                  <Box sx={{ display: 'flex', gap: 1, mt: 1.5 }}>
                    <Button size="small" variant="outlined" onClick={() => setDetalleId(i.id)}>
                      Ver detalle
                    </Button>
                    <Button size="small" variant="contained" sx={{ bgcolor: '#f59e0b' }}
                      onClick={() => setValorarId(i.id)}>
                      💶 Valorar
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {tab === 2 && (
        <Box>
          <Grid container spacing={1.5} sx={{ mb: 2 }} alignItems="center">
            <Grid item xs={12} sm={3}>
              <TextField fullWidth size="small" label="Buscar (cliente, máquina, avería...)"
                value={filtros.search}
                onChange={(e) => cambiarFiltro('search', e.target.value)} />
            </Grid>
            <Grid item xs={6} sm={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Carácter</InputLabel>
                <Select value={filtros.caracter} label="Carácter"
                  onChange={(e) => cambiarFiltro('caracter', e.target.value)}>
                  <MenuItem value="">Todos</MenuItem>
                  {CARACTERES_AVERIA.map(c => <MenuItem key={c.v} value={c.v}>{c.l}</MenuItem>)}
                  <MenuItem value="sin_clasificar">⚠️ Sin clasificar</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Ubicación</InputLabel>
                <Select value={filtros.ubicacion} label="Ubicación"
                  onChange={(e) => cambiarFiltro('ubicacion', e.target.value)}>
                  <MenuItem value="">Todas</MenuItem>
                  {UBICACIONES_AVERIA.map(u => <MenuItem key={u.v} value={u.v}>{u.l}</MenuItem>)}
                  <MenuItem value="sin_clasificar">⚠️ Sin clasificar</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Tipo</InputLabel>
                <Select value={filtros.tipo} label="Tipo"
                  onChange={(e) => cambiarFiltro('tipo', e.target.value)}>
                  <MenuItem value="">Todos</MenuItem>
                  {tipos.map(t => <MenuItem key={t} value={t}>{t}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Origen</InputLabel>
                <Select value={filtros.origen} label="Origen"
                  onChange={(e) => cambiarFiltro('origen', e.target.value)}>
                  <MenuItem value="">Todo</MenuItem>
                  <MenuItem value="crm">Registradas en el SIS</MenuItem>
                  <MenuItem value="historico">Histórico importado</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={2}>
              <TextField fullWidth size="small" label="Desde" type="date"
                InputLabelProps={{ shrink: true }} value={filtros.desde}
                onChange={(e) => cambiarFiltro('desde', e.target.value)} />
            </Grid>
            <Grid item xs={6} sm={2}>
              <TextField fullWidth size="small" label="Hasta" type="date"
                InputLabelProps={{ shrink: true }} value={filtros.hasta}
                onChange={(e) => cambiarFiltro('hasta', e.target.value)} />
            </Grid>
            <Grid item xs={12} sm={8} sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
              <Button size="small" onClick={() => { setPagina(1); setFiltros({ search: '', tipo: '', desde: '', hasta: '', ubicacion: '', caracter: '', origen: '' }); }}>
                Limpiar
              </Button>
              <Button size="small" variant="outlined" startIcon={<span>📊</span>}
                onClick={exportarRepositorio}>
                Exportar a Excel
              </Button>
            </Grid>
          </Grid>

        <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
          <Table size="small" sx={{ minWidth: 1100 }}>
            <TableHead>
              <TableRow sx={{ bgcolor: '#1a1a2e' }}>
                <TableCell sx={{ color: 'white' }}>ID</TableCell>
                <TableCell sx={{ color: 'white' }}>Fecha</TableCell>
                <TableCell sx={{ color: 'white' }}>Máquina</TableCell>
                <TableCell sx={{ color: 'white' }}>Cliente</TableCell>
                <TableCell sx={{ color: 'white' }}>Avería</TableCell>
                <TableCell sx={{ color: 'white' }}>Ubicación</TableCell>
                <TableCell sx={{ color: 'white' }}>Carácter</TableCell>
                <TableCell sx={{ color: 'white' }}>Pieza</TableCell>
                <TableCell sx={{ color: 'white' }}>Tipo</TableCell>
                <TableCell sx={{ color: 'white' }}>Horas</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {historico.map(i => {
                const car = CARACTERES_AVERIA.find(c => c.v === i.averia_caracter);
                const ubi = UBICACIONES_AVERIA.find(u => u.v === i.averia_ubicacion);
                const colorCar: any = { mecanico: 'default', electrico: 'warning',
                  hidraulico: 'info', neumatico: 'secondary', software: 'success' };
                return (
                  <TableRow key={i.id} hover sx={{ cursor: 'pointer' }} onClick={() => setDetalleId(i.id)}>
                    <TableCell>
                      #{i.id}
                      {i.origen_registro === 'historico' && (
                        <Chip label="hist." size="small" variant="outlined"
                          sx={{ ml: 0.5, height: 16, fontSize: 9 }} />
                      )}
                    </TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{i.fecha?.slice(0, 10) || '—'}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                      {(i.modelo || '').replace('SANY ', '')}<br />
                      <Typography variant="caption" color="text.secondary">{i.numero_serie || '—'}</Typography>
                    </TableCell>
                    <TableCell>{i.cliente_nombre || '—'}</TableCell>
                    <TableCell sx={{ maxWidth: 280 }}>{i.descripcion || '—'}</TableCell>
                    <TableCell>
                      {ubi ? ubi.l : <Chip label="sin clasificar" size="small" color="error" variant="outlined" sx={{ height: 20, fontSize: 10 }} />}
                    </TableCell>
                    <TableCell>
                      {car ? <Chip label={car.l} size="small" color={colorCar[i.averia_caracter] || 'default'} sx={{ height: 22 }} />
                           : <Chip label="sin clasificar" size="small" color="error" variant="outlined" sx={{ height: 20, fontSize: 10 }} />}
                    </TableCell>
                    <TableCell sx={{ fontSize: 11 }}>{i.pieza_pn || '—'}</TableCell>
                    <TableCell>{i.tipo_intervencion || '—'}</TableCell>
                    <TableCell>{i.horas ? `${i.horas}h` : '—'}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {historicoPages > 1 && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <Pagination count={historicoPages} page={pagina}
              onChange={(_, p) => setPagina(p)} color="primary" />
          </Box>
        )}
        </Box>
      )}

      {/* Dialog nueva intervención */}
      <Dialog open={nuevaDialog} onClose={(e, r) => { if (r !== 'backdropClick' && r !== 'escapeKeyDown') { setNuevaDialog(false); } }} maxWidth="sm" fullWidth>
        <DialogTitle>➕ Nueva intervención</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <FormControl fullWidth>
              <InputLabel>Tipo de intervención</InputLabel>
              <Select
                value={nueva.tipo_intervencion} label="Tipo de intervención"
                onChange={(e) => setNueva({ ...nueva, tipo_intervencion: e.target.value })}
              >
                {tipos.map(t => <MenuItem key={t} value={t}>{t}</MenuItem>)}
              </Select>
            </FormControl>

            <Autocomplete
              options={clientesLista}
              getOptionLabel={(c: any) => c.nombre}
              onChange={(_, val) => handleClienteChange(val)}
              renderInput={(params) => <TextField {...params} label="Cliente *" />}
            />

            <Autocomplete
              options={maquinasLista}
              getOptionLabel={(m: any) => `${m.modelo} #${m.numero_serie}`}
              disabled={!nueva.cliente_id}
              onChange={(_, val) => setNueva({ ...nueva, maquina_id: val?.id || null })}
              renderInput={(params) => <TextField {...params} label="Máquina *" helperText={!nueva.cliente_id ? 'Selecciona primero un cliente' : ''} />}
            />

            <Autocomplete
              multiple
              options={empleadosLista}
              getOptionLabel={(t: any) => `${t.nombre} ${t.apellidos}`}
              onChange={(_, val) => setNueva({ ...nueva, tecnicos_ids: val.map((v: any) => v.id) })}
              renderInput={(params) => <TextField {...params} label="Técnico(s) asignado(s) *" />}
            />

            <TextField
              label="Descripción inicial" multiline rows={2}
              value={nueva.descripcion}
              onChange={(e) => setNueva({ ...nueva, descripcion: e.target.value })}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setNuevaDialog(false)}>Cancelar</Button>
          <Button onClick={handleCrear} variant="contained" sx={{ bgcolor: '#4f46e5' }}>
            Crear intervención
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog detalle intervención */}
      {detalleId && (
        <DetalleIntervencionDialog
          intervencionId={detalleId}
          permisos={permisosUsuario}
          rol={user.rol}
          puedeBorrar={user.rol === 'admin' || permisosUsuario.includes('gestionar_intervenciones')}
          onClose={() => setDetalleId(null)}
          onActualizado={cargar}
        />
      )}

      <PropuestaFacturaIntervencion open={!!valorarId}
        intervencionId={valorarId}
        modo="valoracion"
        onClose={() => setValorarId(null)}
        onFacturada={cargar} />
    </Box>
  );
}

// ── Componente separado para el detalle (chat, tiempos, materiales) ──
function DetalleIntervencionDialog({ intervencionId, onClose, onActualizado, puedeBorrar, permisos = [], rol }: any) {
  const [intervencion, setIntervencion] = useState<any>(null);
  const [tabDetalle, setTabDetalle] = useState(0);
  const [loading, setLoading] = useState(true);
  const userGlobal = JSON.parse(localStorage.getItem('user') || '{}');
  const [borrarDialog, setBorrarDialog] = useState<any>(null);
  const [borrando, setBorrando] = useState(false);

  const abrirBorrado = async () => {
    try {
      const resumen = await previsualizarBorradoIntervencion(intervencionId);
      setBorrarDialog(resumen);
    } catch (e: any) {
      alert('No se pudo comprobar: ' + (e.response?.data?.detail || e.message));
    }
  };

  const confirmarBorrado = async () => {
    setBorrando(true);
    try {
      await borrarIntervencion(intervencionId);
      setBorrarDialog(null);
      onClose();
      onActualizado?.();
    } catch (e: any) {
      alert('Error al borrar: ' + (e.response?.data?.detail || e.message));
    } finally {
      setBorrando(false);
    }
  };


  const cargar = () => {
    getIntervencionDetalle(intervencionId).then(setIntervencion).finally(() => setLoading(false));
  };

  useEffect(() => { cargar(); }, [intervencionId]);

  if (loading) return (
    <Dialog open onClose={onClose}><DialogContent><CircularProgress /></DialogContent></Dialog>
  );

  const esAdminGlobal = rol === 'admin' || permisos.includes('gestionar_intervenciones');
  const puedeVerEconomico = rol === 'admin' || permisos.includes('cost_control_maquinas');
    const PESTAÑAS = [
    { id: 'tiempos',    label: '⏱ Tiempos' },
    { id: 'materiales', label: '📦 Materiales' },
    { id: 'gastos',     label: '💳 Gastos' },
    ...(puedeVerEconomico ? [{ id: 'economico', label: '💰 Control proyecto' }] : []),
    { id: 'informe',    label: '📝 Informe' },
    ...(esAdminGlobal ? [{ id: 'editar', label: '⚙️ Editar' }] : []),
    { id: 'fotos',      label: '📷 Fotos' },
  ];
  const pestañaActual = PESTAÑAS[tabDetalle]?.id || 'tiempos';

  return (
    <Dialog open maxWidth="md" fullWidth
      onClose={(e, r) => { if (r !== 'backdropClick' && r !== 'escapeKeyDown') onClose(); }}>
      <DialogTitle>
        #{intervencion.id} — {intervencion.tipo_intervencion} — {intervencion.cliente_nombre}
      </DialogTitle>
      <DialogContent>
        <Tabs value={tabDetalle} onChange={(_, v) => setTabDetalle(v)} variant="scrollable" scrollButtons="auto" sx={{ mb: 2 }}>
          {PESTAÑAS.map((p: any) => <Tab key={p.id} label={p.label} />)}
        </Tabs>

        {pestañaActual === 'tiempos' && <TiemposTab intervencion={intervencion} onActualizado={cargar} />}
        {pestañaActual === 'materiales' && <MaterialesTab intervencion={intervencion} onActualizado={cargar} permisos={permisos} />}
        {pestañaActual === 'gastos' && <GastosTab intervencion={intervencion} onActualizado={cargar} />}
        {pestañaActual === 'economico' && <EconomicoTab intervencion={intervencion} onActualizado={cargar} />}
        {pestañaActual === 'informe' && <InformeTab intervencion={intervencion} permisos={permisos} onActualizado={() => { cargar(); onActualizado(); }} />}
        {pestañaActual === 'editar' && <EditarTab intervencion={intervencion} onActualizado={() => { cargar(); onActualizado(); }} />}
        {pestañaActual === 'fotos' && <FotosTab intervencion={intervencion} />}
      </DialogContent>
      <DialogActions>
        {puedeBorrar && (
          <Button color="error" onClick={abrirBorrado} sx={{ mr: 'auto' }}>
            🗑️ Borrar intervención
          </Button>
        )}
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>

      {/* Confirmacion de borrado, con el detalle de lo que se deshace */}
      <Dialog open={!!borrarDialog} onClose={() => setBorrarDialog(null)} maxWidth="sm" fullWidth>
        <DialogTitle>🗑️ Borrar intervención #{intervencionId}</DialogTitle>
        <DialogContent>
          {borrarDialog?.bloqueo ? (
            <Alert severity="error">{borrarDialog.bloqueo}</Alert>
          ) : borrarDialog && (
            <Box sx={{ mt: 1 }}>
              <Alert severity="warning" sx={{ mb: 2 }}>
                Esta acción no se puede deshacer.
              </Alert>
              <Typography variant="body2" sx={{ mb: 1 }}>Al borrarla:</Typography>
              <Box component="ul" sx={{ pl: 3, m: 0 }}>
                {borrarDialog.devoluciones?.length > 0 && (
                  <li>
                    <b>Vuelven al almacén</b> {borrarDialog.devoluciones.reduce((s: number, d: any) => s + d.total, 0)} unidad(es):
                    <Box component="ul" sx={{ pl: 2 }}>
                      {borrarDialog.devoluciones.map((d: any) => (
                        <li key={d.recambio_id}>{d.referencia} — {d.nombre} ({d.total} ud.)</li>
                      ))}
                    </Box>
                  </li>
                )}
                {borrarDialog.tiempos > 0 && <li>Se borran {borrarDialog.tiempos} registro(s) de tiempo</li>}
                {borrarDialog.materiales > 0 && <li>Se borran {borrarDialog.materiales} material(es) solicitados</li>}
                {borrarDialog.fotos > 0 && <li>Se borran {borrarDialog.fotos} foto(s)</li>}
                {borrarDialog.gastos > 0 && <li>Se borran {borrarDialog.gastos} gasto(s)</li>}
                {borrarDialog.venta_pendiente && <li>Se elimina la venta pendiente de facturar</li>}
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBorrarDialog(null)}>Cancelar</Button>
          <Button color="error" variant="contained" onClick={confirmarBorrado}
            disabled={borrando || !!borrarDialog?.bloqueo}>
            {borrando ? 'Borrando...' : 'Sí, borrar'}
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
}

function TiemposTab({ intervencion, onActualizado }: any) {
  const hoy = new Date().toISOString().slice(0, 10);
  const [linea, setLinea] = useState<any>({
    fecha: hoy, hora_inicio: '', hora_fin: '', tipo_tiempo: 'trabajo',
    es_festivo: false, km_desplazamiento: '', dietas_completas: 0,
    medias_dietas: 0, notas: ''
  });
  const [preview, setPreview] = useState<any>(null);
  const [guardando, setGuardando] = useState(false);
  const [editandoId, setEditandoId] = useState<number | null>(null);

  // Marca festivo automáticamente si la fecha cae en sábado o domingo
  const cambiarFecha = (fecha: string) => {
    const dia = new Date(fecha + 'T12:00:00').getDay();
    setLinea({ ...linea, fecha, es_festivo: dia === 0 || dia === 6 });
  };

  // Cálculo en vivo
  useEffect(() => {
    if (!linea.hora_inicio || !linea.hora_fin) { setPreview(null); return; }
    const t = setTimeout(() => {
      calcularTiempo({
        ...linea,
        km_desplazamiento: parseFloat(linea.km_desplazamiento) || 0,
      }).then(setPreview).catch(() => setPreview(null));
    }, 400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linea.fecha, linea.hora_inicio, linea.hora_fin, linea.tipo_tiempo,
      linea.es_festivo, linea.km_desplazamiento, linea.dietas_completas, linea.medias_dietas]);

  const handleAñadir = async () => {
    if (!linea.hora_inicio || !linea.hora_fin) { alert('Indica la hora de inicio y de fin'); return; }
    setGuardando(true);
    try {
      const datos = { ...linea, km_desplazamiento: parseFloat(linea.km_desplazamiento) || 0 };
      if (editandoId) {
        await editarTiempo(intervencion.id, editandoId, datos);
      } else {
        await añadirTiempo(intervencion.id, datos);
      }
      setEditandoId(null);
      setLinea({ ...linea, hora_inicio: '', hora_fin: '', km_desplazamiento: '',
        dietas_completas: 0, medias_dietas: 0, notas: '' });
      setPreview(null);
      onActualizado();
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Error al guardar el tiempo');
    } finally {
      setGuardando(false);
    }
  };

  const empezarEdicion = (t: any) => {
    setEditandoId(t.id);
    setLinea({
      fecha: t.fecha, hora_inicio: t.hora_inicio || '', hora_fin: t.hora_fin || '',
      tipo_tiempo: t.tipo_tiempo || 'trabajo', es_festivo: !!t.es_festivo,
      km_desplazamiento: t.km_desplazamiento || '', dietas_completas: t.dietas_completas || 0,
      medias_dietas: t.medias_dietas || 0, notas: t.notas || '',
    });
  };

  const cancelarEdicion = () => {
    setEditandoId(null);
    setLinea({ fecha: hoy, hora_inicio: '', hora_fin: '', tipo_tiempo: 'trabajo',
      es_festivo: false, km_desplazamiento: '', dietas_completas: 0, medias_dietas: 0, notas: '' });
    setPreview(null);
  };

  const esViaje = linea.tipo_tiempo === 'desplazamiento';
  const eur = (n: number) => (n || 0).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });

  return (
    <Box>
      <Card sx={{ mb: 3, borderRadius: 2 }}>
        <CardContent>
          <Typography sx={{ fontWeight: 700, mb: 2 }}>
            {editandoId ? '✏️ Editando tiempo registrado' : 'Registrar tiempo'}
          </Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={3}>
              <TextField fullWidth size="small" type="date" label="Fecha"
                InputLabelProps={{ shrink: true }} value={linea.fecha}
                onChange={(e) => cambiarFecha(e.target.value)} />
            </Grid>
            <Grid item xs={6} sm={2}>
              <TextField fullWidth size="small" type="time" label="Desde"
                InputLabelProps={{ shrink: true }} value={linea.hora_inicio}
                onChange={(e) => setLinea({ ...linea, hora_inicio: e.target.value })} />
            </Grid>
            <Grid item xs={6} sm={2}>
              <TextField fullWidth size="small" type="time" label="Hasta"
                InputLabelProps={{ shrink: true }} value={linea.hora_fin}
                onChange={(e) => setLinea({ ...linea, hora_fin: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Tipo</InputLabel>
                <Select value={linea.tipo_tiempo} label="Tipo"
                  onChange={(e) => setLinea({ ...linea, tipo_tiempo: e.target.value })}>
                  <MenuItem value="trabajo">🔧 Trabajo</MenuItem>
                  <MenuItem value="desplazamiento">🚚 Desplazamiento</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormControlLabel
                control={<Switch checked={linea.es_festivo}
                  onChange={(e) => setLinea({ ...linea, es_festivo: e.target.checked })} />}
                label="Festivo" />
            </Grid>

            {/* Solo en desplazamiento */}
            {esViaje && (
              <>
                <Grid item xs={6} sm={3}>
                  <TextField fullWidth size="small" type="number" label="Kilómetros"
                    value={linea.km_desplazamiento}
                    onChange={(e) => setLinea({ ...linea, km_desplazamiento: e.target.value })} />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <TextField fullWidth size="small" type="number" label="Dietas completas"
                    value={linea.dietas_completas}
                    onChange={(e) => setLinea({ ...linea, dietas_completas: parseInt(e.target.value) || 0 })} />
                </Grid>
                <Grid item xs={6} sm={3}>
                  <TextField fullWidth size="small" type="number" label="Medias dietas"
                    value={linea.medias_dietas}
                    onChange={(e) => setLinea({ ...linea, medias_dietas: parseInt(e.target.value) || 0 })} />
                </Grid>
              </>
            )}

            <Grid item xs={12} sm={esViaje ? 3 : 8}>
              <TextField fullWidth size="small" label="Notas" value={linea.notas}
                onChange={(e) => setLinea({ ...linea, notas: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button fullWidth variant="contained" onClick={handleAñadir}
                  disabled={guardando || !linea.hora_inicio || !linea.hora_fin}
                  sx={{ bgcolor: editandoId ? '#f59e0b' : '#4f46e5' }}>
                  {guardando ? 'Guardando...' : (editandoId ? 'Guardar cambios' : 'Añadir tiempo')}
                </Button>
                {editandoId && (
                  <Button variant="outlined" onClick={cancelarEdicion}>Cancelar</Button>
                )}
              </Box>
            </Grid>
          </Grid>

          {/* Desglose calculado */}
          {preview && preview.desglose?.length > 0 && (
            <Alert severity="info" sx={{ mt: 2 }}>
              <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
                {preview.horas} h{preview.importe_venta != null ? ` · Total: ${eur(preview.importe_venta)}` : ''}
              </Typography>
              {preview.desglose.map((d: any, i: number) => (
                <Typography key={i} variant="caption" display="block">
                  {d.cantidad}{d.precio != null ? ` × ${eur(d.precio)} = ${eur(d.importe)}` : ''} ({d.concepto})
                </Typography>
              ))}
            </Alert>
          )}
        </CardContent>
      </Card>

       <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Técnico</TableCell>
              <TableCell>Fecha</TableCell>
              <TableCell>Horario</TableCell>
              <TableCell>Tipo</TableCell>
              <TableCell>Horas</TableCell>
              <TableCell>Km</TableCell>
              {(intervencion.tiempos || []).some((t: any) => t.importe_venta != null) && (
                <TableCell align="right">Importe</TableCell>
              )}
              <TableCell align="center">✏️</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {intervencion.tiempos?.map((t: any) => (
              <TableRow key={t.id}>
                <TableCell>{t.nombre} {t.apellidos}</TableCell>
                <TableCell>{t.fecha}</TableCell>
                <TableCell>{t.hora_inicio || '—'} - {t.hora_fin || '—'}</TableCell>
                <TableCell>
                  {t.tipo_tiempo === 'desplazamiento' ? '🚚' : '🔧'}
                  {t.es_festivo ? ' 🎌' : ''}
                </TableCell>
                <TableCell>{t.horas_trabajo}h</TableCell>
                <TableCell>{t.km_desplazamiento || 0}km</TableCell>
                {t.importe_venta != null && (
                  <TableCell align="right" sx={{ fontWeight: 600 }}>
                    {eur(t.importe_venta)}
                  </TableCell>
                )}
                <TableCell align="center">
                  <IconButton size="small" title="Editar este tiempo"
                    onClick={() => empezarEdicion(t)}
                    disabled={editandoId === t.id}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

function MaterialesTab({ intervencion, onActualizado, permisos = [] }: any) {
  const [recambiosLista, setRecambiosLista] = useState<any[]>([]);
  const [material, setMaterial] = useState({ recambio_id: null as any, referencia_nueva: '', descripcion_nueva: '', cantidad: 1 });
  const userMat = JSON.parse(localStorage.getItem('user') || '{}');
  const esAdmin = userMat.rol === 'admin' || (permisos || []).includes('gestionar_intervenciones');
  const [procesando, setProcesando] = useState<number | null>(null);

  useEffect(() => { getRecambios('', 1).then(d => setRecambiosLista(d.items)); }, []);

  const handleSolicitar = async () => {
    await solicitarMaterial(intervencion.id, material);
    setMaterial({ recambio_id: null, referencia_nueva: '', descripcion_nueva: '', cantidad: 1 });
    onActualizado();
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}>
        <Autocomplete
          options={recambiosLista}
          getOptionLabel={(r: any) => `${r.referencia} — ${r.nombre}`}
          onChange={(_, val) => setMaterial({ ...material, recambio_id: val?.id || null })}
          renderInput={(params) => <TextField {...params} label="Buscar recambio existente" />}
        />
        <Typography variant="caption" color="text.secondary">— o si es una pieza nueva —</Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField label="Referencia nueva" value={material.referencia_nueva} onChange={(e) => setMaterial({ ...material, referencia_nueva: e.target.value })} />
          <TextField label="Descripción" value={material.descripcion_nueva} onChange={(e) => setMaterial({ ...material, descripcion_nueva: e.target.value })} sx={{ flex: 1 }} />
        </Box>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField label="Cantidad" type="number" value={material.cantidad} onChange={(e) => setMaterial({ ...material, cantidad: parseFloat(e.target.value) || 1 })} sx={{ width: 120 }} />
          <Button variant="contained" onClick={handleSolicitar} sx={{ bgcolor: '#4f46e5' }}>Solicitar material</Button>
        </Box>
      </Box>

      {intervencion.materiales?.map((m: any) => (
        <Card key={m.id} sx={{ mb: 1, borderLeft: `3px solid ${m.estado === 'aprobado' ? '#22c55e' : m.estado === 'rechazado' ? '#ef4444' : '#f59e0b'}` }}>
          <CardContent sx={{ py: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box>
                <Typography variant="body2">
                  {m.recambio_nombre || m.descripcion_nueva} ({m.recambio_referencia || m.referencia_nueva}) — Cant: {m.cantidad}
                </Typography>
                <Chip label={m.estado} size="small" color={m.estado === 'aprobado' ? 'success' : m.estado === 'rechazado' ? 'error' : 'warning'} sx={{ mt: 0.5 }} />
              </Box>
             {esAdmin && (
                <Box sx={{ display: 'flex', gap: 1 }}>
                  {m.estado === 'pendiente' && (
                    <>
                      <Button size="small" variant="contained" sx={{ bgcolor: '#22c55e' }} disabled={procesando === m.id} onClick={async () => { setProcesando(m.id); try { await aprobarMaterial(m.id); onActualizado(); } finally { setProcesando(null); } }}>
                        ✅
                      </Button>
                      <Button size="small" variant="outlined" color="error" disabled={procesando === m.id} onClick={async () => { setProcesando(m.id); try { await rechazarMaterial(m.id); onActualizado(); } finally { setProcesando(null); } }}>
                        ❌
                      </Button>
                    </>
                  )}
                  <Button size="small" variant="outlined" color="error" disabled={procesando === m.id} onClick={async () => { const aviso = m.estado === 'aprobado' ? `¿Eliminar este material? Se devolverán ${m.cantidad} unidad(es) al almacén.` : '¿Eliminar este material de la intervención?'; if (!window.confirm(aviso)) return; setProcesando(m.id); try { await eliminarMaterial(m.id); onActualizado(); } catch (e: any) { alert(e.response?.data?.detail || 'No se pudo eliminar'); } finally { setProcesando(null); } }}>
                    🗑️
                  </Button>
                </Box>
              )}
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}

function EconomicoTab({ intervencion, onActualizado }: any) {
  const [datos, setDatos] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [editandoTarifas, setEditandoTarifas] = useState(false);
  const [tarifas, setTarifas] = useState({ precio_hora: 35, coste_hora: 20 });

  const cargar = () => {
    getControlEconomico(intervencion.id).then(d => {
      setDatos(d);
      setTarifas({ precio_hora: d.precio_hora, coste_hora: d.coste_hora });
    }).finally(() => setLoading(false));
  };

  useEffect(() => { cargar(); }, [intervencion.id]);

  const handleGuardarTarifas = async () => {
    await actualizarTarifas(intervencion.id, tarifas);
    setEditandoTarifas(false);
    cargar();
    onActualizado();
  };

  if (loading || !datos) return <CircularProgress />;

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="subtitle2">Tarifas aplicadas</Typography>
        <Button size="small" onClick={() => setEditandoTarifas(!editandoTarifas)}>
          {editandoTarifas ? 'Cancelar' : 'Editar tarifas'}
        </Button>
      </Box>

      {editandoTarifas && (
        <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
          <TextField label="Precio venta hora (€)" type="number" value={tarifas.precio_hora} onChange={(e) => setTarifas({ ...tarifas, precio_hora: parseFloat(e.target.value) || 0 })} />
          <TextField label="Coste hora (€)" type="number" value={tarifas.coste_hora} onChange={(e) => setTarifas({ ...tarifas, coste_hora: parseFloat(e.target.value) || 0 })} />
          <Button variant="contained" onClick={handleGuardarTarifas} sx={{ bgcolor: '#4f46e5' }}>Guardar</Button>
        </Box>
      )}

      <TableContainer component={Paper} sx={{ mb: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#1a1a2e' }}>
              <TableCell sx={{ color: 'white' }}>Concepto</TableCell>
              <TableCell sx={{ color: 'white' }}>Cantidad</TableCell>
              <TableCell sx={{ color: 'white' }}>Coste</TableCell>
              <TableCell sx={{ color: 'white' }}>Venta</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Horas trabajo</TableCell>
              <TableCell>{datos.horas_totales}h</TableCell>
              <TableCell>{datos.coste_horas.toFixed(2)}€</TableCell>
              <TableCell>{datos.venta_horas.toFixed(2)}€</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Desplazamiento</TableCell>
              <TableCell>{datos.km_totales}km</TableCell>
              <TableCell>{datos.coste_km.toFixed(2)}€</TableCell>
              <TableCell>{datos.venta_km.toFixed(2)}€</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Materiales</TableCell>
              <TableCell>—</TableCell>
              <TableCell>{datos.coste_materiales.toFixed(2)}€</TableCell>
              <TableCell>{datos.venta_materiales.toFixed(2)}€</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Card sx={{ bgcolor: '#fef2f2', textAlign: 'center', p: 2 }}>
            <Typography variant="caption">Coste total</Typography>
            <Typography variant="h6" sx={{ color: '#ef4444', fontWeight: 600 }}>{datos.coste_total.toFixed(2)}€</Typography>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card sx={{ bgcolor: '#eff6ff', textAlign: 'center', p: 2 }}>
            <Typography variant="caption">Venta total</Typography>
            <Typography variant="h6" sx={{ color: '#3b82f6', fontWeight: 600 }}>{datos.venta_total.toFixed(2)}€</Typography>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card sx={{ bgcolor: datos.margen >= 0 ? '#f0fdf4' : '#fef2f2', textAlign: 'center', p: 2 }}>
            <Typography variant="caption">Margen</Typography>
            <Typography variant="h6" sx={{ color: datos.margen >= 0 ? '#22c55e' : '#ef4444', fontWeight: 600 }}>
              {datos.margen.toFixed(2)}€ ({datos.margen_pct}%)
            </Typography>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

function EditarTab({ intervencion, onActualizado }: any) {
  const [tipos, setTipos] = useState<string[]>([]);
  const [empleadosLista, setEmpleadosLista] = useState<any[]>([]);
  const [datos, setDatos] = useState({
    tipo_intervencion: intervencion.tipo_intervencion,
    descripcion: intervencion.descripcion || '',
    estado: intervencion.estado,
    averia_ubicacion: intervencion.averia_ubicacion || '',
    averia_caracter: intervencion.averia_caracter || '',
  });
  const [tecnicosSeleccionados, setTecnicosSeleccionados] = useState<any[]>(intervencion.tecnicos || []);

  useEffect(() => {
    getTiposIntervencion().then(setTipos);
    getUsuarios().then(setEmpleadosLista);
  }, []);

  const handleGuardarDatos = async () => {
    await actualizarDatosIntervencion(intervencion.id, datos);
    onActualizado();
    alert('✅ Datos actualizados');
  };

  const handleGuardarTecnicos = async () => {
    await actualizarTecnicosIntervencion(intervencion.id, tecnicosSeleccionados.map(t => t.id));
    onActualizado();
    alert('✅ Técnicos actualizados');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Datos generales</Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormControl fullWidth>
            <InputLabel>Tipo de intervención</InputLabel>
            <Select value={datos.tipo_intervencion} label="Tipo de intervención" onChange={(e) => setDatos({ ...datos, tipo_intervencion: e.target.value })}>
              {tipos.map(t => <MenuItem key={t} value={t}>{t}</MenuItem>)}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel>Estado</InputLabel>
            <Select value={datos.estado} label="Estado" onChange={(e) => setDatos({ ...datos, estado: e.target.value })}>
              <MenuItem value="en_curso">En curso</MenuItem>
              <MenuItem value="pendiente_aprobacion">Pendiente aprobación</MenuItem>
              <MenuItem value="pendiente_valoracion">Pendiente de valoración</MenuItem>
              <MenuItem value="completada">Completada</MenuItem>
            </Select>
          </FormControl>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
            Clasificación de la avería (alimenta el repositorio)
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <FormControl fullWidth>
              <InputLabel>Ubicación</InputLabel>
              <Select value={datos.averia_ubicacion} label="Ubicación"
                onChange={(e) => setDatos({ ...datos, averia_ubicacion: String(e.target.value) })}>
                <MenuItem value=""><em>Sin clasificar</em></MenuItem>
                {UBICACIONES_AVERIA.map(u => <MenuItem key={u.v} value={u.v}>{u.l}</MenuItem>)}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>Carácter</InputLabel>
              <Select value={datos.averia_caracter} label="Carácter"
                onChange={(e) => setDatos({ ...datos, averia_caracter: String(e.target.value) })}>
                <MenuItem value=""><em>Sin clasificar</em></MenuItem>
                {CARACTERES_AVERIA.map(c => <MenuItem key={c.v} value={c.v}>{c.l}</MenuItem>)}
              </Select>
            </FormControl>
          </Box>
          <TextField label="Descripción" multiline rows={3} value={datos.descripcion} onChange={(e) => setDatos({ ...datos, descripcion: e.target.value })} />
          <Button variant="contained" onClick={handleGuardarDatos} sx={{ bgcolor: '#4f46e5' }}>Guardar datos</Button>
        </Box>
      </Box>

      <Box>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Técnicos asignados</Typography>
        <Autocomplete
          multiple
          options={empleadosLista}
          value={tecnicosSeleccionados}
          getOptionLabel={(t: any) => `${t.nombre} ${t.apellidos}`}
          isOptionEqualToValue={(opt, val) => opt.id === val.id}
          onChange={(_, val) => setTecnicosSeleccionados(val)}
          renderInput={(params) => <TextField {...params} label="Técnicos" />}
          sx={{ mb: 2 }}
        />
        <Button variant="contained" onClick={handleGuardarTecnicos} sx={{ bgcolor: '#4f46e5' }}>Actualizar técnicos</Button>
      </Box>
    </Box>
  );
}

function InformeTab({ intervencion, onActualizado, permisos = [] }: any) {
  const [informe, setInforme] = useState(intervencion.informe_texto || '');
  const [notas, setNotas] = useState('');
  const [generando, setGenerando] = useState(false);
  const [incidencia, setIncidencia] = useState('');
  const [devolverDialog, setDevolverDialog] = useState(false);
  const [notaDevolucion, setNotaDevolucion] = useState('');
  const [aprobarDialog, setAprobarDialog] = useState(false);
  const [clasif, setClasif] = useState({
    averia_ubicacion: intervencion.averia_ubicacion || '',
    averia_caracter: intervencion.averia_caracter || '',
  });
  const _u = JSON.parse(localStorage.getItem('user') || '{}');
  const esAdmin = _u.rol === 'admin' || (permisos || []).includes('aprobar_intervenciones');

  const handleGenerar = async () => {
    if (!notas.trim()) { alert('Escribe primero lo que has hecho en esta jornada'); return; }
    setGenerando(true);
    try {
      const hoy = new Date();
      const fechaISO = hoy.toISOString().slice(0, 10);
      const fechaES = hoy.toLocaleDateString('es-ES');
      const previo = (informe || '').trim();
      const data = await generarInformeIA(intervencion.id, notas, previo, fechaISO);

      const redaccion = data.informe_servicio || '';
      if (!previo) {
        // Primera jornada: incidencia arriba y el relato debajo
        setInforme(
          (data.incidencia ? `INCIDENCIA:\n${data.incidencia}\n\n` : '') +
          (redaccion ? `INFORME DE SERVICIO:\n\n— Jornada del ${fechaES} —\n${redaccion}` : '')
        );
      } else {
        // Jornadas siguientes: se añade al final, sin tocar lo anterior
        const yaHoy = previo.includes(`— Jornada del ${fechaES} —`);
        setInforme(`${previo}\n\n— Jornada del ${fechaES} —\n${redaccion}`.trim());
        if (yaHoy) {
          setTimeout(() => alert(
            'Ya había una entrada de hoy en el informe. Se ha añadido otra: ' +
            'revisa el texto y únelas si hace falta.'), 100);
        }
      }
      if (data.incidencia && !incidencia) setIncidencia(data.incidencia);
      setNotas('');   // se vacían las notas: ya están redactadas en el informe
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Error al generar el informe');
    } finally {
      setGenerando(false);
    }
  };

  const handleGuardarBorrador = async () => {
    if (!informe.trim()) { alert('El informe está vacío'); return; }
    await guardarInforme(intervencion.id, informe, false);
    onActualizado();
    alert('💾 Informe guardado. La intervención sigue en curso.');
  };

  const handleEnviar = async () => {
    if (!informe.trim()) { alert('El informe está vacío'); return; }
    if (!window.confirm(
      'Se enviará el informe para su aprobación y la intervención dejará de estar en curso.\n\n' +
      '¿Has terminado todos los trabajos?')) return;
    await guardarInforme(intervencion.id, informe, true);
    onActualizado();
    alert('✅ Informe enviado para aprobación');
  };

  const handleAprobar = async () => {
    try {
      await aprobarIntervencion(intervencion.id, clasif);
      setAprobarDialog(false);
      onActualizado();
      alert('✅ Intervención aprobada y cerrada');
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Error al aprobar');
    }
  };

  const handleDevolver = async () => {
    try {
      await rechazarIntervencion(intervencion.id, notaDevolucion.trim());
      setDevolverDialog(false);
      setNotaDevolucion('');
      onActualizado();
      alert('↩️ Intervención devuelta al técnico. Se le ha notificado por email.');
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Error al devolver la intervención');
    }
  };

  const completada = intervencion.estado === 'completada';

  return (
    <Box>
      {/* Asistente IA — solo si no está completada */}
      {!completada && (
        <Card sx={{ mb: 3, borderRadius: 2, border: '1px solid', borderColor: 'divider',
          bgcolor: 'background.default' }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
              <Typography sx={{ fontWeight: 600 }}>Asistente de informe</Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
            Escribe en lenguaje normal lo que has hecho <b>en esta jornada</b>. Se redactará
            en lenguaje técnico y se añadirá al informe con la fecha de hoy, sin borrar lo
            de los días anteriores.
            </Typography>
            <TextField
              label="Notas del técnico" multiline rows={4} fullWidth
              placeholder="Ej: Revisé la grúa, la válvula de presión del circuito hidráulico estaba fallando, la sustituí y probé en carga..."
              value={notas} onChange={(e) => setNotas(e.target.value)}
              sx={{ mb: 1.5 }}
            />
            <Button
              variant="contained" onClick={handleGenerar}
              disabled={generando || !notas.trim()}
              startIcon={generando ? <CircularProgress size={18} color="inherit" /> : <span>🪝</span>}
              sx={{ bgcolor: '#F5C200', color: '#0D0D0D', fontWeight: 600,
                '&:hover': { bgcolor: '#d9ab00' } }}
            >
              {generando ? 'Generando...' : 'Generar informe'}
            </Button>
          </CardContent>
        </Card>
      )}

      {/* Informe (editable) */}
      <TextField
        label="Informe de la intervención" multiline rows={12} fullWidth
        value={informe} onChange={(e) => setInforme(e.target.value)}
        disabled={completada}
        helperText={!completada ? 'Puedes editar el texto generado antes de guardar' : ''}
        sx={{ mb: 2 }}
      />

      {!completada && (
        <>
          <Button variant="outlined" onClick={handleGuardarBorrador} sx={{ mr: 1 }}>
            💾 Guardar
          </Button>
          <Button variant="contained" onClick={handleEnviar} sx={{ bgcolor: '#4f46e5', mr: 1 }}>
            📤 Enviar para aprobación
          </Button>
        </>
      )}
      {intervencion.nota_devolucion && intervencion.estado === 'en_curso' && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          <b>Devuelta para revisión:</b> {intervencion.nota_devolucion}
        </Alert>
      )}
      {esAdmin && intervencion.estado === 'pendiente_aprobacion' && (
        <>
          <Button variant="contained" onClick={() => setAprobarDialog(true)} sx={{ bgcolor: '#22c55e', mr: 1 }}>
            ✅ Aprobar y cerrar intervención
          </Button>
          <Button variant="outlined" color="warning" onClick={() => setDevolverDialog(true)} sx={{ mr: 1 }}>
            ↩️ Devolver al técnico
          </Button>
        </>
      )}
        <Button variant="outlined" onClick={() => descargarInformeIntervencion(intervencion.id)}
                sx={{ borderColor: '#F5C200', color: '#a07c00', '&:hover': { borderColor: '#d9ab00', bgcolor: 'rgba(245,194,0,0.08)' } }}>
                📄 Descargar PDF
              </Button>
      <InformeAcciones intervencion={intervencion} onActualizado={onActualizado} />

      <Dialog open={aprobarDialog} maxWidth="xs" fullWidth
        onClose={(e, r) => { if (r !== 'backdropClick') setAprobarDialog(false); }}>
        <DialogTitle>✅ Clasificar y cerrar la intervención</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Estos dos datos alimentan el repositorio de averías. Son obligatorios para cerrar.
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <FormControl fullWidth>
              <InputLabel>¿Dónde está la avería?</InputLabel>
              <Select label="¿Dónde está la avería?" value={clasif.averia_ubicacion}
                onChange={(e) => setClasif({ ...clasif, averia_ubicacion: String(e.target.value) })}>
                {UBICACIONES_AVERIA.map(u => <MenuItem key={u.v} value={u.v}>{u.l}</MenuItem>)}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>¿De qué carácter es?</InputLabel>
              <Select label="¿De qué carácter es?" value={clasif.averia_caracter}
                onChange={(e) => setClasif({ ...clasif, averia_caracter: String(e.target.value) })}>
                {CARACTERES_AVERIA.map(c => <MenuItem key={c.v} value={c.v}>{c.l}</MenuItem>)}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAprobarDialog(false)}>Cancelar</Button>
          <Button variant="contained" onClick={handleAprobar} sx={{ bgcolor: '#22c55e' }}
            disabled={!clasif.averia_ubicacion || !clasif.averia_caracter}>
            Aprobar y cerrar
          </Button>
        </DialogActions>
      </Dialog>

      {/* DIALOG DEVOLVER AL TÉCNICO */}
      <Dialog open={devolverDialog} onClose={(e, r) => { if (r !== 'backdropClick' && r !== 'escapeKeyDown') { setDevolverDialog(false); } }} maxWidth="sm" fullWidth>
        <DialogTitle>↩️ Devolver intervención al técnico</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, mt: 1 }}>
            La intervención volverá a estado "En curso" y los técnicos asignados
            recibirán un email con tu nota.
          </Typography>
          <TextField
            fullWidth multiline rows={3} label="Motivo de la devolución *"
            placeholder="Ej: Falta detallar la causa de la avería en el informe, y añade una foto del componente sustituido."
            value={notaDevolucion}
            onChange={(e) => setNotaDevolucion(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDevolverDialog(false)}>Cancelar</Button>
          <Button variant="contained" color="warning" onClick={handleDevolver}
            disabled={!notaDevolucion.trim()}>
            Devolver al técnico
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
function FotosTab({ intervencion }: any) {
  const [fotos, setFotos] = useState<any[]>([]);
  const [urls, setUrls] = useState<Record<number, string>>({});
  const [titulo, setTitulo] = useState('');
  const [subiendo, setSubiendo] = useState(false);
  const [ampliada, setAmpliada] = useState<number | null>(null);

  const cargarFotos = async () => {
    try {
      const lista = await getFotosIntervencion(intervencion.id);
      setFotos(lista);
      const nuevas: Record<number, string> = {};
      for (const f of lista) {
        try { nuevas[f.id] = await getFotoIntervencionBlob(f.id); } catch { /* miniatura no disponible */ }
      }
      setUrls(nuevas);
    } catch {
      setFotos([]);
    }
  };

  useEffect(() => {
    cargarFotos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intervencion.id]);

  const handleSubir = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const archivos = Array.from(e.target.files || []);
    e.target.value = ''; // permite volver a elegir el mismo archivo
    if (!archivos.length) return;
    setSubiendo(true);
    const fallos: string[] = [];
    try {
      for (const file of archivos) {
        try {
          await subirFotoIntervencion(intervencion.id, file, titulo);
        } catch (err: any) {
          fallos.push(`${file.name}: ${err.response?.data?.detail || 'error'}`);
        }
      }
      setTitulo('');
      await cargarFotos();
      if (fallos.length) {
        alert(`No se pudieron subir ${fallos.length} de ${archivos.length}:\n` + fallos.join('\n'));
      }
    } finally {
      setSubiendo(false);
    }
  };

  const handleBorrar = async (fotoId: number) => {
    if (!window.confirm('¿Eliminar esta foto?')) return;
    try {
      await borrarFotoIntervencion(fotoId);
      await cargarFotos();
    } catch (err: any) {
      alert(err.response?.data?.detail || 'Error al eliminar la foto');
    }
  };

  return (
    <Box>
      {/* Subir foto */}
      <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap', alignItems: 'center' }}>
        <TextField size="small" label="Título (opcional)" value={titulo}
          onChange={(e) => setTitulo(e.target.value)} sx={{ flex: 1, minWidth: 180 }} />
        <Button variant="contained" component="label" disabled={subiendo}
          sx={{ bgcolor: '#4f46e5' }}>
          {subiendo ? 'Subiendo...' : '📷 Hacer foto'}
          <input type="file" accept="image/*" capture="environment" hidden onChange={handleSubir} />
        </Button>
        <Button variant="outlined" component="label" disabled={subiendo}
          sx={{ color: '#4f46e5', borderColor: '#4f46e5' }}>
          📎 Adjuntar
          <input type="file" accept="image/*" multiple hidden onChange={handleSubir} />
        </Button>
      </Box>

      {fotos.length === 0 ? (
        <Alert severity="info">No hay fotos en esta intervención todavía.</Alert>
      ) : (
        <Grid container spacing={2}>
          {fotos.map((f: any) => (
            <Grid item xs={6} sm={4} md={3} key={f.id}>
              <Card sx={{ borderRadius: 2 }}>
                <Box sx={{ height: 130, overflow: 'hidden', cursor: 'pointer', bgcolor: '#f0f0f0' }}
                  onClick={() => setAmpliada(f.id)}>
                  {urls[f.id] && (
                    <img src={urls[f.id]} alt={f.titulo || 'Foto'}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  )}
                </Box>
                <CardContent sx={{ py: 1, '&:last-child': { pb: 1 } }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box sx={{ minWidth: 0 }}>
                      <Typography variant="caption" sx={{ fontWeight: 600, display: 'block' }} noWrap>
                        {f.titulo || 'Sin título'}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" noWrap display="block">
                        {f.fecha?.slice(0, 16)} · {f.subido_por_nombre || '—'}
                      </Typography>
                    </Box>
                    <IconButton size="small" color="error" onClick={() => handleBorrar(f.id)}>
                      🗑
                    </IconButton>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Foto ampliada */}
      <Dialog open={!!ampliada} onClose={(e, r) => { if (r !== 'backdropClick' && r !== 'escapeKeyDown') { setAmpliada(null); } }} maxWidth="lg">
        <DialogContent sx={{ p: 1 }}>
          {ampliada && urls[ampliada] && (
            <img src={urls[ampliada]} alt="Foto ampliada"
              style={{ maxWidth: '100%', maxHeight: '80vh', display: 'block' }} />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}